export default {
  methods: {
    formatPrice(price) {
      return Number(price).toLocaleString('fr-FR', {
        maximumFractionDigits: 0
      });
    }
  }
}
